import {Component} from '@angular/core';
import {Router} from "@angular/router";
// import {UserService} from "../core/services/user.service";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html'
})

export class SidebarComponent {
    // constructor(private router: Router, private userService: UserService) {
    // }


}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/layout/sidebar.component.ts